// src/components/UI/MenuPanel.js
import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const MenuPanel = ({ onMenuClose, onSupportClick }) => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  // Obfuscate the support email address to deter bots.
  const supportUser = "support";
  const supportDomain = "clascity.com";
  const supportEmail = `${supportUser}@${supportDomain}`;

  // Logout function: clears authentication data and navigates to the login page.
  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    onMenuClose();
    navigate("/login");
  };

  return (
    <div className="nav-menu text-center">
      <ul className="nav-item">
        <li>
          <Link to="/" onClick={onMenuClose}>Home</Link>
        </li>
        <li>
          <Link to="/admin" onClick={onMenuClose}>Manage Questions</Link>
        </li>
        <li>
          <Link to="/admin/account-settings" onClick={onMenuClose}>Account Settings</Link>
        </li>
        <li>
          <Link 
            to="#"
            onClick={(e) => {
              e.preventDefault();
              onSupportClick();
              onMenuClose();
            }}>
            Support
          </Link>
        </li>
        <li>
          <Link to="/login" onClick={handleLogout} className="logout-button">Logout</Link>
        </li>
      </ul>
    </div>
  );
};

export default MenuPanel;
